<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadSummaryModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
        <span :class="{'col-width': isMobile}">
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ leadHeader | capitalize }}</b></span>
          <span :title="$t('leads.table.has_hearing_loss')" v-if="selectedLead.hasHearingLoss" class="mr-2">
            <small style="cursor: default">{{$t('leads.table.hl')}}</small>
          </span>
          <span :title="$t('leads.table.diagnosed_hl')" v-if="selectedLead.diagnosed_hl" class="mr-2">
            <small style="cursor: default">{{$t('leads.table.dhl')}}</small>
          </span>
          <span :title="$t('leads.table.qualified_lead')" v-if="selectedLead.qualified_at" class="mr-2">
            <small style="cursor: default">{{$t('leads.table.ql')}}</small>
          </span>
          <span v-if="selectedLead.hearingLossResult" class="mr-2">
            <span v-if="selectedLead.hearingLossResult == 'mild'" :title="$t('leads.table.hl_mild') +' (' + Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right) + ' dB)'" class="i-evollu-hl-mild" style="vertical-align: text-bottom;"></span>
            <span v-if="selectedLead.hearingLossResult == 'severe'" :title="$t('leads.table.has_hearing_loss') +' (' + Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right) + ' dB)'" class="i-evollu-hl-severe" style="vertical-align: text-bottom;"></span>
            <span v-if="selectedLead.hearingLossResult == 'normal'" :title="$t('leads.table.no_hearing_loss', {dbs: Math.max(selectedLead.ht.hl_left, selectedLead.ht.hl_right)})" class="i-evollu-hl-normal" style="vertical-align: text-bottom;"></span>
          </span>
          <span v-if="selectedLead.answers && selectedLead.questionnaire_score < 20" :title="$t('leads.table.questionnaire_low_score') + ' (' + selectedLead.questionnaire_score + ')'" class="i-evollu-questionnaire mr-2" style="vertical-align: text-bottom;"></span>
          <span v-if="selectedLead.questionnaire_score >= 20" :title="$t('leads.table.questionnaire_score') + ' (' + selectedLead.questionnaire_score + ')'" class="i-evollu-questionnaire-danger mr-2" style="vertical-align: text-bottom;"></span>
          <span v-if="selectedLead.hearing_aid" :title="$t('leads.table.hearing_aid')" class="i-evollu-hearing-aid mr-2" style="vertical-align: text-bottom;"></span>
          <span v-if="selectedLead.solsticio_response !== null" class="mr-2">
            <span v-if="selectedLead.solsticio_response == 0" :title="$t('leads.table.is_from_solsticio_tooltips.0')" class="i-evollu-solsticio-no-loss" style="vertical-align: text-bottom;"></span>
            <span v-if="selectedLead.solsticio_response == 1" :title="$t('leads.table.is_from_solsticio_tooltips.1')" class="i-evollu-solsticio-loss" style="vertical-align: text-bottom;"></span>
          </span>
        </span>
        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>

      <LeadInfo
        :selectedLead="selectedLead"
        :entitiesWrite="entitiesWrite"
        :showCreateAgendaEvent="agendaEventsEntitiesWrite.length > 0"
        @openPrivacyPolicyModal="openPrivacyPolicyModal"
        @openLeadTransferModal="openLeadTransferModal"
        @openAgendaEventForm="openAgendaEventFormModal"
        @openLeadUpdateEntityModal="openLeadUpdateEntityModal"/>

      <hr class="separator-lead-details">

      <FollowUp
        :pursues="selectedLead.pursues"
        :selected-lead-id="selectedLead.id"
        :selected-lead-entity-id="selectedLead.entity_id"
        :sale-price-entities-read="salePriceEntitiesRead"
        :sale-price-entities-write="salePriceEntitiesWrite"
        :entities-write="entitiesWrite"
        :lead-status="selectedLead.status"
        :service="service"
        @deletedPursue="deletedPursue"
        @createdPursue="createdPursue" />

      <hr class="separator-lead-details">

      <Questionnaire
        :answers="selectedLead.answers" />

      <hr class="separator-lead-details">

      <HearingTest
        v-if="selectedLead.ht"
        :ht="selectedLead.ht" />

      <span v-for="ht in selectedLead.ht_web" :key="ht.id">
        <hr>
        <HearingTestWeb :ht="ht"></HearingTestWeb>
      </span>

      <div v-if="selectedLead.iframe_session_id && iframeSessionStatsData !== null">
        <hr>
        <h4> {{$t('leads.details.iframe_session_stats')}}</h4>
        <va-card class="w-100">
          <h3>{{ this.$t('iframe.statistics.sessions.totals_per_page') }}</h3>
          <div class="row totalsGraph">
            <apexchart height="380" width="600" type="bar" :options="pagesVisitsStatsChartOptions" :series="pagesVisitsStatsSeries"></apexchart>
          </div>
        </va-card>

        <va-card class="w-100">
          <h3>{{ this.$t('iframe.statistics.sessions.mean_secs_per_page') }}</h3>
          <div class="row totalsGraph">
            <apexchart height="380" width="600" type="bar" :options="pagesAvgTimeStatsChartOptions" :series="pagesAvgTimeStatsSeries"></apexchart>
          </div>
        </va-card>
      </div>

    </va-modal>

    <PrivacyPolicyModal
      v-if="showPrivacyPolicyModal && (selectedLead.privacy_policy || selectedLead.consent_id)"
      :url="handlePrivacyUrl(selectedLead)"
      :is-consent-url="selectedLead.consent_id !== null && selectedLead.consent_id !== ''"
      @cancel="onCancelPrivacyPolicyModal"
    />

    <LeadUpdateEntityModal
      v-if="showLeadUpdateEntityModal"
      :selectedLead="selectedLead"
      :entitiesWrite="entities.filter(entity => entitiesWrite.includes(entity.id))"
      @closeUpdateEntityModal="updateLeadEntityModalClosed"
      @updatedLeadEntity="updateLeadEntity" />

    <LeadSessionTransfer
      v-if="showLeadTransferModal"
      :selectedLead="selectedLead"
      @closeLeadModal="sessionTransferModalClosed"
      @updatedSession="updatedSession" />

    <EventFormModal
      v-if="showEventForm"
      :facilities="controloQualidadeFacilitiesOptions"
      :service="service"
      :eventTypePrevent="'appointment'"
      :lead="selectedLead"
      @modal-closed="eventFormModalClosed"
      @event-created="eventCreated"
      @event-updated="eventFormModalClosed"
      @event-deleted="eventFormModalClosed"
      :showDatePickers="false"/>

  </div>
</template>
<script>
import LeadInfo from './LeadInfo'
import FollowUp from './FollowUp'
import Questionnaire from './Questionnaire'
import HearingTest from '@/components/common/HearingTest'
import HearingTestWeb from './HearingTestWeb'
import LeadSessionTransfer from './LeadSessionTransfer'
import PrivacyPolicyModal from '@/components/leads/PrivacyPolicyModal'
import EventFormModal from "@/components/leads-agenda/EventFormModal";
import {flatten, uniqBy} from "lodash";
import LeadUpdateEntityModal from "@/components/leads/LeadUpdateEntityModal.vue";
import {IframeService} from "@/api/IframeService";
export default {
  components: {
    LeadUpdateEntityModal,
    EventFormModal,
    FollowUp,
    LeadInfo,
    HearingTest,
    HearingTestWeb,
    Questionnaire,
    PrivacyPolicyModal,
    LeadSessionTransfer
  },
  props: {
    selectedLead: {
      type: Object,
      required: true
    },
    entities: {
      type: Array,
      required: true
    },
    entitiesWrite: {
      type: Array,
      required: true
    },
    salePriceEntitiesRead: {
      type: Array,
      required: true
    },
    salePriceEntitiesWrite: {
      type: Array,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      showLeadTransferModal: false,
      showPrivacyPolicyModal: false,
      showLeadUpdateEntityModal: false,
      showEventForm: false,
      controloQualidadeFacilitiesOptions: [],
      iframeSessionStatsData: null,
      pagesVisitsStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#015a60'],
        dataLabels: {
          enabled: true
        },
      },
      pagesAvgTimeStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#6cb412'],
        dataLabels: {
          enabled: true
        },
      }
    }
  },
  async mounted() {
    this.showModal = true

    this.controloQualidadeFacilitiesOptions = this.agendaEventsEntitiesWrite
    this.controloQualidadeFacilitiesOptions = this.controloQualidadeFacilitiesOptions.filter(elem => elem.activity_id === 11 && elem.status === 0)
    this.controloQualidadeFacilitiesOptions = uniqBy(flatten(this.controloQualidadeFacilitiesOptions.map(item => {
      return item.facilities
    })), 'id')

    if (this.selectedLead.iframe_session_id !== null) {
      this.iframeSessionStatsData = await IframeService.getSessionStatistics(this.selectedLead.iframe_session_id)
    }

  },
  methods: {
    eventCreated: function({ event }) {
      this.showEventForm = false
      this.$emit('eventCreated')
      this.showModal = false

    },
    eventFormModalClosed: function() {
      this.showEventForm = false
      this.showModal = true
    },
    handlePrivacyUrl: function (selectedLead) {
      if((selectedLead.consent_id !== null && selectedLead.consent_id !== '') && process.env.VUE_APP_CONSENT_URL) {
        return `${process.env.VUE_APP_CONSENT_URL}v1/consent/${selectedLead.consent_id}`
      }
      return selectedLead.privacy_policy
    },
    openLeadTransferModal: function () {
      this.showModal = false
      this.showLeadTransferModal = true
    },
    openLeadUpdateEntityModal: function() {
      this.showModal = false
      this.showLeadUpdateEntityModal = true
    },
    openAgendaEventFormModal: function () {
      this.showModal = false
      this.showEventForm = true
    },
    openPrivacyPolicyModal: function () {
      this.showModal = false
      this.showPrivacyPolicyModal = true
    },
    onCancelPrivacyPolicyModal: function () {
      this.showPrivacyPolicyModal = false
      this.showModal = true
    },
    sessionTransferModalClosed: function () {
      this.showLeadTransferModal = false
      this.showModal = true
    },
    updateLeadEntityModalClosed: function () {
      this.showLeadUpdateEntityModal = false
      this.showModal = true
    },
    createdPursue (data) {
      this.selectedLead.pursues.push(data.newPursue)
      this.selectedLead.status = data.newPursue.status
      this.selectedLead.qualified_at = data.qualifiedAt
    },
    deletedPursue (data) {
      this.selectedLead.status = data.leadStatus
      this.selectedLead.qualified_at = data.qualifiedAt
      this.selectedLead.pursues = this.selectedLead.pursues.filter(pursue => {
        return pursue.id !== data.pursueToDelete.id
      })
    },
    updatedSession ({ lead }) {
      // Update datatable
      this.$emit('updatedSession', { lead })
      this.showLeadTransferModal = false
      this.showModal = true
    },
    updateLeadEntity (lead) {
      this.$emit('updatedLeadEntity', {lead})
      this.showLeadUpdateEntityModal = false
      this.showModal = true
    }
  },
  computed: {
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
    agendaEventsPermission: function () {
      return this.service.user_permissions.filter(permission => permission.info_type === 2200)
    },
    agendaEventsEntitiesWrite: function () {
      return this.service.entities.filter(entity => this.agendaEventsPermission.some(permission => (permission.entity_id === entity.id || permission.entity_id === null) && permission.access_type >= 2))
    },
    leadHeader: function () {
      let header = ''
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + ' ' + this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name
      }
      return header
    },
    pagesVisitsStatsSeries: function() {
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.iframeSessionStatsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: elem.totalVisited,
        })
      })
      return data
    },
    pagesAvgTimeStatsSeries: function() {
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.iframeSessionStatsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: Math.round(elem.avgTimeSpentSeconds),
        })
      })
      return data
    },
  }
}
</script>
